import { type FC } from 'react';
import type { FormLabelProps } from './types';
import { FormLabel as ChakraUiFormLabel } from '@chakra-ui/react';

export const FormLabel: FC<FormLabelProps> = ({ children, ...props }) => {
  return (
    <ChakraUiFormLabel
      position="absolute"
      left="16px"
      transform="translateY(-50%)"
      transition="all 0.1s ease-in-out"
      pointerEvents="none"
      {...props}
    >
      {children}
    </ChakraUiFormLabel>
  )
}
